/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DispatchProductsResponseDto } from '../models/dispatch-products-response-dto';
import { productsControllerBatch } from '../fn/products/products-controller-batch';
import { ProductsControllerBatch$Params } from '../fn/products/products-controller-batch';
import { productsControllerImport } from '../fn/products/products-controller-import';
import { ProductsControllerImport$Params } from '../fn/products/products-controller-import';
import { productsControllerSearch } from '../fn/products/products-controller-search';
import { ProductsControllerSearch$Params } from '../fn/products/products-controller-search';
import { productsControllerSync } from '../fn/products/products-controller-sync';
import { ProductsControllerSync$Params } from '../fn/products/products-controller-sync';
import { SearchProductsResponseDto } from '../models/search-products-response-dto';

/**
 * Product write and search operations
 */
@Injectable()
export class ProductsServiceProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productsControllerBatch()` */
  static readonly ProductsControllerBatchPath = '/api/v1/products/batch';

  /**
   * Queue a batch of product mutations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerBatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerBatch$Response(
    params: ProductsControllerBatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<DispatchProductsResponseDto>> {
    const obs = productsControllerBatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Queue a batch of product mutations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerBatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerBatch(
    params: ProductsControllerBatch$Params,
    context?: HttpContext
  ): Observable<DispatchProductsResponseDto> {
    const resp = this.productsControllerBatch$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<DispatchProductsResponseDto>): DispatchProductsResponseDto => r.body
      )
    );
  }

  /** Path part for operation `productsControllerImport()` */
  static readonly ProductsControllerImportPath = '/api/v1/products/import';

  /**
   * Queue product imports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerImport$Response(
    params: ProductsControllerImport$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<DispatchProductsResponseDto>> {
    const obs = productsControllerImport(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Queue product imports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerImport(
    params: ProductsControllerImport$Params,
    context?: HttpContext
  ): Observable<DispatchProductsResponseDto> {
    const resp = this.productsControllerImport$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<DispatchProductsResponseDto>): DispatchProductsResponseDto => r.body
      )
    );
  }

  /** Path part for operation `productsControllerSearch()` */
  static readonly ProductsControllerSearchPath = '/api/v1/products';

  /**
   * Search products for the authenticated store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerSearch$Response(
    params: ProductsControllerSearch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<SearchProductsResponseDto>> {
    const obs = productsControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search products for the authenticated store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerSearch(
    params: ProductsControllerSearch$Params,
    context?: HttpContext
  ): Observable<SearchProductsResponseDto> {
    const resp = this.productsControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SearchProductsResponseDto>): SearchProductsResponseDto => r.body)
    );
  }

  /** Path part for operation `productsControllerSync()` */
  static readonly ProductsControllerSyncPath = '/api/v1/products/sync';

  /**
   * Queue a product synchronization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerSync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerSync$Response(
    params: ProductsControllerSync$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<DispatchProductsResponseDto>> {
    const obs = productsControllerSync(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Queue a product synchronization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerSync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerSync(
    params: ProductsControllerSync$Params,
    context?: HttpContext
  ): Observable<DispatchProductsResponseDto> {
    const resp = this.productsControllerSync$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<DispatchProductsResponseDto>): DispatchProductsResponseDto => r.body
      )
    );
  }
}
